/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk } from "@reduxjs/toolkit";
import { getQuizResultsByActivityIdApi } from "@/api/reportingApi";
import { mapQuizResultsApiData } from "@/utils/reportingDataMapper";
import { MappedQuizResult } from "@/ts/interfaces/Reporting/QuizResultsInterface";

export const getQuizResultsByActivityIdThunk = createAsyncThunk<
    MappedQuizResult,
    { eukaId: string; activityId: string },
    { rejectValue: string }
>(
    "reporting/quizResults/fetchByActivityId",
    async ({ eukaId, activityId }, { rejectWithValue }) => {
        try {
            const { data } = await getQuizResultsByActivityIdApi(eukaId, activityId);
            const mapped = mapQuizResultsApiData(data?.data);
            return mapped;
        } catch (err: any) {
            return rejectWithValue(
                err?.response?.data?.message ?? err?.message ?? "Failed to load quiz results"
            );
        }
    }
);
